import React, { useEffect } from "react";
import "../../Coporate-travel-management/CorporateBanner/CorporateBanner.css";
import BannerWrapper from "../../../commonComponents/BannerWrapper";
import HeadingH1 from "../../../utls/HeadingH1";
const PartnersBanner = ({ onLoad }) => {
  return (
    <BannerWrapper onLoad={onLoad}>
      {({ useHighRes, imageLoaded, handleImageLoad }) => (
        <div className="container-fluid ctm-banner position-relative p-0" style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}>
          <img
            src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/Partners.webp"
            alt="Contact Banner"
            className="w-100"
            // For high-speed, use eager loading; for low-speed, lazy loading.
            loading={useHighRes ? "eager" : "lazy"}
            // Attach the onLoad handler only for high-speed connections.
            onLoad={handleImageLoad}
            fetchpriority={useHighRes ? "high" : "auto"}
          />
          {imageLoaded &&
            <div className="ctm-text position-absolute text-white mt-xxl-4 mt-3">
              <p className="fs4 text-uppercase busy">TOGETHER</p>
              <HeadingH1 className="banner-headings w-75">We Build Stronger Partnerships</HeadingH1>
              <div className="d-flex common-second-content partners">
                <div className="ornge-border"></div>
                <div className="second-content">
                  Beyond destinations, we focus on your journey. Let’s make a promise! Together, we’ll
                  craft the perfect solution for your team, ensuring success every step of the way.
                </div>
              </div>
            </div>
          }
        </div>
      )}
    </BannerWrapper>
  );
};

export default PartnersBanner;
